import React, { JSX, useRef } from 'react';
import Icons from 'components/atoms/Icons';

type SearchShareProps = {
  active: boolean;
};

const SearchShare = (props: SearchShareProps): JSX.Element => {
  const { active } = props;

  const ref = useRef<HTMLParagraphElement>(null);

  const handleClick = () => {
    if (ref.current) {
      ref.current.innerText = 'Copied to Clipboard';
      setTimeout(() => {
        if (ref.current) ref.current.innerText = 'Copy Link';
      }, 2000);
    }
  };

  return (
    <div className={`search-share control-panel ${active ? 'active' : ''}`}>
      <button
        className="search-share-button"
        onClick={() => {
          window.print();
        }}
      >
        <Icons id="icon-print" className="icon icon-print" />
        <p className="osf-link">Print</p>
      </button>
      <button
        className="search-share-button"
        onClick={() => {
          navigator.clipboard.writeText(window.location.href).then(
            () => {
              handleClick();
            },
            () => {
              console.log('failed to copy link to clipboard');
            }
          );
        }}
      >
        <Icons id="copy" className="icon icon-copy rotate-left" />
        <p ref={ref} className="osf-link">
          Copy Link
        </p>
      </button>
    </div>
  );
};

export default SearchShare;
